export const htmlFollow = async (row, company, param, uv) => {
    var today = new Date()
    var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][today.getMonth()];
    var sDate = 'Curitiba, ' + today.getDate() + ' de ' + month + ' de ' + today.getFullYear() + '.'
    var name, cpf, crdd
    if (uv.length > 0){
        name = uv[0].name
        cpf = uv[0].document
        crdd = uv[0].crdd
    }
    if (uv.length > 1){
        name += '<br>' + uv[1].name
        cpf += '<br>' + uv[1].document
        crdd += '<br>' + uv[1].crdd
    }
        if (uv.length > 2){
        name += '<br>' + uv[2].name
        cpf += '<br>' + uv[2].document
        crdd += '<br>' + uv[2].crdd
    }
    if (uv.length > 3){
        name += '<br>' + uv[3].name
        cpf += '<br>' + uv[3].document
        crdd += '<br>' + uv[3].crdd
    }
    let html =
        '<html> ' +
        '<head> ' +
        '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" /> ' +
        '</head> ' +
        '<body> ' +
        '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/crdd.png" ' +
                'style="position: absolute; left: 0px; top: 0px; width: 230; height: 230; z-index: -1;" ' +
            '/> ' +
            '<div style="font-size: 30; margin-left: 300;  margin-top: 120; width: 150;  ">CERTIDÃO</div> ' +
            '<div style="font-size: 15; margin-left: 50;  margin-top: 50; width: 600; ">&emsp;&emsp;&emsp;Certificamos para os devidos fins e efeitos, nos termos do Inciso III do Art. 5° e do Art. 12° da Lei Federal N° 14.282 de 2021 que a empresa abaixo qualificada, encontra-se devidamente inscrita perante o Conselho Regional dos Despachantes Documentalistas do estado do Paraná - CRDD-PR.:</div> ' +
 
            '<div style="font-size: 12; border-style: groove; margin-left: 50;  margin-top: 50; width: 600; height: 40; text-align: center; ">Razão Social: ' + company.name + '<br>CNPJ n° ' + company.document + ' - Município de ' + company.city + '-PR</div>' +

            '<div style="display: flex; margin-top:30px; margin-left:-30px; height: 65">' +
            '<div style="font-size: 12; width:50%; float:left; text-align:center;">NOME<br>'+name+'</div>' +
            '<div style="font-size: 12; width:20%; float:left; text-align:center;">CPF<br>'+cpf+'</div>' +
            '<div style="font-size: 12; width:30%; float:left; text-align:center;">INSCRIÇÃO CRDD-PR<br>'+crdd+'</div>' +
            '</div>' +

            '<div style="font-size: 15; margin-left: 50;  margin-top: 50; width: 600;  ">A presente certidão tem validade de 06 meses.</div> ' +
            '<div style="font-size: 15; margin-left: 50;  margin-top: 40; width: 600;  ">' + sDate + '</div> ' +


            '<div style="display: flex; margin-top:50px">' +
            '<div style="width:50%; float:left; text-align:center;">'+
            '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura01.png" ' +
                'style="margin-top: 15;"' +
            //    'style="position: absolute; left: 120px; top: 770px; z-index: -1;" ' +
            '/> ' +
            '<br>' + param.president+'<br>Presidente</div>' +
            '<div style="width:50%; float:left; text-align:center;">' +
            '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura02.png" ' +
            //    'style="position: absolute; left: 450px; top: 750px; z-index: -1;" ' +
            '/> ' +
            '<br>' + param.director+'<br>Diretor de Cadastro e Reg. Profissional</div>' +
            '</div>' +

            '<div id="qrcode" style="margin-left: 300; margin-top: 50"></div>' + 

            '<div style="font-size: 10; margin-left: 300">Escaneie o QRCODE para <br>verificar a autenticidade</div>' +

            '<div style="font-size: 13; margin-left: 50;  margin-top: 60; width: 600; text-align: center; ">' + param.name + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">' + param.address + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">Email: ' + param.email + ' Site: ' + param.site + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">Fone: ' + param.phone + '</div> ' 

/*        for (var i=0; i<10; i++){
            if (i < questoes.length){
                html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                    (i+1) + ' - ' + questoes[i].pergunta +
                    '</div> ' +
                    '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                    respostas[i] + 
                    '</div> '
            }
        }
        html += '<div style="break-after:page"></div> '
        if (questoes.length > 10){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=10; i<20; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
        }
        html += '<div style="break-after:page"></div> '
        if (questoes.length > 20){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=20; i<30; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 30){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=30; i<40; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }

        if (questoes.length > 40){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=40; i<50; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 50){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=50; i<60; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 60){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=60; i<70; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 70){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=70; i<80; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 80){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=80; i<90; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 90){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=90; i<100; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }*/
        html += '<script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>' +
            '<script>' +
            'new QRCode(document.getElementById("qrcode"), {text: "https://api-dot-crdd-api.rj.r.appspot.com/api/certificate/validatecompany/'+ company._id + '", width: 120, height: 120, colorDark: "#000000", colorLight: "#ffffff",});' +
            '</script>' 

        html += '</body> ' +
            '</html>'
    return html;
}

